import React from 'react'
import "./Footer.css"
import { useNavigate } from 'react-router-dom'

function Footer() {

    const navigate = useNavigate()

  return (
    <>
    {/* <div className="prehero w-100 py-2">
        <p className="preheroText mb-0">Save $120 <span className='color-change-span'>and Design at Home </span>- <span onClick={()=>{navigate("/contact")}}>Start Now</span></p>

      </div> */}
    <div className='Footer-container pt-5 pb-4'>
        <div className='container'>
            <div className='d-flex flex-lg-row flex-column align-items-center gap-lg-5 gap-3 justify-content-center pb-lg-1 pb-3'>
                <p className='links-text mb-0' onClick={()=>{navigate("/elastron-fabric")}}>Elastron Fabric</p>
                <p className='links-text mb-0' onClick={()=>{navigate("/3m-di-noc")}}>3M Di-NOC</p>
                <p className='links-text mb-0' onClick={()=>{navigate("/3d-decorative-walls")}}>3D Decorative Walls</p>
                <p className='links-text mb-0' onClick={()=>{navigate("/partnership-opportunities")}}>Partnership</p>
                <p className='links-text mb-0' onClick={()=>{navigate("/blog")}}>Blogs</p>
                <p className='links-text mb-0' onClick={()=>{navigate("/contact")}}>Contact</p>
            </div>

            <p className='body-paragraph text-center mt-3'>All content is copyright <span className='color-light'>© HALTON SURFACE SYSTEM {new Date().getFullYear()}.</span> All rights reserved. | Website designed by <span className='color-light cursor-pointer' onClick={()=>{window.open("https://www.creativesquad.ca/","blank")}}>Creative Squad</span></p>

            <div className='d-flex flex-lg-row flex-column align-items-center gap-3 justify-content-center terms-link-container mx-auto'>
                <p className='links-text mb-0 color-dark' onClick={()=>{navigate("/terms-condition")}}>Our Terms & Conditions  </p>
                {/* <p className=' mb-0 color-dark d-lg-block d-none'>|</p>
                <p className='links-text mb-0 color-dark'>Privacy Policy</p>
                <p className=' mb-0 color-dark d-lg-block d-none'>|</p>
                <p className='links-text mb-0 color-dark'>Manage Cookies  </p> */}
            </div>

            <div className='d-flex mt-4 w-100 align-items-center justify-content-center gap-3 social-link-container'>
                <img src='/images/icons/google-footer-icon.png' onClick={()=>{window.open("https://g.page/r/CafFlWMaUZeHEBM/review")}} alt='Twitter' className='img-fluid'/>
                <img src='/images/icons/fb-footer-icon.png' onClick={()=>{window.open("https://facebook.com/haltonsurfacesystems")}} alt='facebook' className='img-fluid'/>
                <img src='/images/icons/ig-footer-icon.png' onClick={()=>{window.open("https://instagram.com/haltonsurfacesystems")}} alt='Instagram' className='img-fluid'/>
                {/* <img src='/images/icons/x-footer-icon.png' onClick={()=>{window.open("")}} alt='Twitter' className='img-fluid'/> */}
                <img src='/images/icons/li-footer-icon.png' onClick={()=>{window.open("https://www.linkedin.com/company/haltonsurfacesystems/")}} alt='LinkedIn' className='img-fluid'/>


            </div>
        </div>
    </div>
    </>
  )
}

export default Footer